import axiosInstance from "services/AxiosInstance";

export const deleteQuestionnaireService = async ({ questionnaireId }: { questionnaireId: string }): Promise<void> =>
  await axiosInstance.delete(`questionnaire/${questionnaireId}`);
